import { dataEventsUrl } from "../../api";

export const PROJECTS_CHANGED_EVENT = "lumen:projects-changed";
export const DATA_CHANGED_EVENT = "lumen:data-changed";
const DATA_CHANGED_STORAGE_KEY = "lumen:data-changed-at";

/**
 * Notify active views and other open tabs that server-backed sidebar data
 * changed. The storage write is only a cross-tab signal; the data itself is
 * still fetched by the receiving view.
 */
export function notifyDataChanged() {
  window.dispatchEvent(new Event(PROJECTS_CHANGED_EVENT));
  window.dispatchEvent(new Event(DATA_CHANGED_EVENT));
  try {
    window.localStorage.setItem(DATA_CHANGED_STORAGE_KEY, String(Date.now()));
  } catch {
    // Storage may be unavailable; the in-tab events still provide the update.
  }
}

export function subscribeToServerDataChanges(listener: () => void) {
  if (typeof EventSource === "undefined") return () => undefined;
  const source = new EventSource(dataEventsUrl(), { withCredentials: true });
  // Notifications are advisory and are not replayed. Reconcile after the
  // initial connection and every reconnect, including titles changed offline.
  source.addEventListener("open", listener);
  source.addEventListener("data-changed", listener);
  return () => {
    source.removeEventListener("open", listener);
    source.removeEventListener("data-changed", listener);
    source.close();
  };
}

export function subscribeToDataChanges(listener: () => void) {
  const onStorage = (event: StorageEvent) => {
    if (event.key === DATA_CHANGED_STORAGE_KEY) listener();
  };
  window.addEventListener(DATA_CHANGED_EVENT, listener);
  window.addEventListener("storage", onStorage);
  return () => {
    window.removeEventListener(DATA_CHANGED_EVENT, listener);
    window.removeEventListener("storage", onStorage);
  };
}
